var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.apiOffline)?_c('OfflineView'):[_c('ErrorModalComponent'),_c('div',{staticClass:"main-content"},[_c('HeaderComponent'),_c('router-view',{key:_vm.$route.path})],1),_c('FooterComponent')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }